/* global attachEvent, slideToggle */

window.addEventListener('spectoCmsContentLoaded', () => {
  injection.attachEvent('.article-menu__button', 'click', (articleBtn) => {
    const parent = articleBtn.target.closest('.article-menu');
    const content = parent.querySelector('.article-menu__content');
    parent.classList.toggle('is-active');
    injection.slideToggle(content, 300, 'block');
  });
});
